<div class="contenitore" *ngIf="!showReward">
  <div class="contenitore_titolo">
    Buon<br />
    Compleanno!
  </div>

  <app-scratch-card
    imgStart="/assets/img/salotto_1.jpg"
    imgEnd="/assets/img/salotto_2.jpg"
    [percentage]="80"
    (showReward)="showReward = true"
  ></app-scratch-card>

  <div class="contenitore_descrizione">
    Scorri con il dito sopra la foto e scopri la festa che ti attende!
  </div>
</div>

<!-- ATTENZIONE - Mostrare questo contenuto dopo aver grattato la superficie della torta -->
<app-reward *ngIf="showReward"></app-reward>
